// Directly reuse display-plus-campaigns/src/shared/model/campaign-criterion.js
// TODO: remove later. Just a temp placeholder
import { omit, isEmpty } from 'underscore';
import { readCampaignCriterions } from '@bingads-webui-campaign-react/display-plus-campaigns';
import { CRITERION_LEVEL, getTargetCriterion as getTargetCriterionForAdGroup, modelToViewModelForTargetCriterions as modelToViewModelForTargetCriterionsBase } from '@bingads-webui-campaign-react/xandr-campaign';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { convertLocationStateToLocationSchemaCampaign } from '@bingads-webui-campaign/hotel-common-targets';

import { PLACEHOLDER_ID } from '../constants';

export {
  readDayTimeCriterions,
  viewModelToBulkModelForAdSchedules,
} from '@bingads-webui-campaign-react/display-plus-campaigns';
export const RemovedDeviceBidAdjustment = -100;

export const readLocationCriterions = ({
  cid,
  aid,
  campaignId,
}) =>
  readCampaignCriterions({
    cid,
    aid,
    campaignId,
    type: "isof(Criterion,'Model.LocationCriterion') or isof(Criterion,'Model.RadiusCriterion') or isof(Criterion,'Model.LocationIntentCriterion')",
  });

export const readAgeAndGenderTargetingCriterions = ({
  cid,
  aid,
  campaignId,
}) =>
  readCampaignCriterions({
    cid,
    aid,
    campaignId,
    type: "isof(Criterion,'Model.AgeCriterion') or isof(Criterion,'Model.GenderCriterion')",
  });

export const readTargetingCriterions = ({
  cid,
  aid,
  campaignId,
}) =>
  readCampaignCriterions({
    cid,
    aid,
    campaignId,
    type: "isof(Criterion,'Model.AgeCriterion') or isof(Criterion,'Model.GenderCriterion') or isof(Criterion,'Model.DeviceCriterion') or isof(Criterion,'Model.GenreCriterion') or isof(Criterion, 'Model.IndustryCriterion') or isof(Criterion, 'Model.JobFunctionCriterion') or isof(Criterion, 'Model.CompanyNameCriterion') or isof(Criterion, 'Model.ContextualTarget')",
  });

export const readAudienceCriterions = ({
  cid,
  aid,
  campaignId,
}) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Campaigns.$withKey(campaignId)
    .AudienceAssociations
    .get({ top: 2000 })
    .toPromise();


export const modelToViewModelForCampaignLevelAudienceCriterions = ({ model }) => {
  const initialAudiences = model.map(audience => ({
    CriterionType: audience.CriterionType,
    Id: audience.Id,
    Status: audience.Status,
    Criterion: {
      AudienceId: audience.AudienceCriterion.AudienceId,
      AudienceName: audience.AudienceCriterion.AudienceName,
      AudienceType: audience.AudienceCriterion.AudienceType,
      BidMultiplier: audience.AudienceCriterion.BidMultiplier,
      Type: audience.AudienceCriterion.Type,
    },
    Campaign: audience.Campaign,
    BidType: audience.BidType,
  }));

  return {
    initialAudiences,
    audiences: initialAudiences,
  };
};

export const getTargetCriterion = ({
  targets,
  type,
  propKey,
  adGroupViewModel,
  campaignViewModel,
  bidAdjustment,
  overrideType = undefined,
}) => (adGroupViewModel ? getTargetCriterionForAdGroup({
  targets,
  type,
  propKey,
  adGroupViewModel,
  campaignViewModel,
  bidAdjustment,
  overrideType,
}) : getTargetCriterionForCampaign({
  targets,
  type,
  propKey,
  campaignViewModel,
  bidAdjustment,
  overrideType,
}));

export const viewModelToBulkModelForAudiences = ({ campaignViewModel }) => {
  if (campaignViewModel.data.audienceRestricted) {
    return [];
  }
  const audiences = campaignViewModel.data.audiences || [];
  const initialAudiences = campaignViewModel.data.initialAudiences || [];

  const added = audiences.filter(audience => !initialAudiences.find(initialAudience => initialAudience.Criterion.AudienceId === audience.Criterion.AudienceId && initialAudience.Criterion.BidMultiplier === audience.Criterion.BidMultiplier));
  const removed = initialAudiences.filter(initialAudience => !audiences.find(audience => audience.Criterion.AudienceId === initialAudience.Criterion.AudienceId && initialAudience.Criterion.BidMultiplier === audience.Criterion.BidMultiplier)).map(audience => ({
    ...audience,
    Status: 'Deleted',
  }));

  return [...added, ...removed].map((audience) => {
    const Status = isEmpty(audience.Status) ? 'Active' : audience.Status;

    const typePrefix = audience.Status === 'Excluded' ? 'Negative' : '';
    const criterionType = `${typePrefix}${audience.Criterion.AudienceType}`;

    if (campaignViewModel.data.Id) {
      return {
        ...audience,
        Status,
        CriterionType: criterionType,
        Campaign: {
          Id: campaignViewModel.data.Id,
        },
      };
    }

    return {
      ...audience,
      Status,
      CriterionType: criterionType,
      CampaignName: campaignViewModel.data.Name,
      Campaign: {
        Id: PLACEHOLDER_ID.CampaignNegativeReferenceId,
      },
    };
  });
};

// Supports both campaign level and ad group level
// For campaign level, pass in campaignViewModel only
// Expects both wrapped in { data: ...}
export const viewModelToBulkModelForTargeting = ({
  campaignViewModel,
  adGroupViewModel,
}) => {
  const parentEntity = adGroupViewModel || campaignViewModel;

  // device
  const deviceTargets = [];

  const { devices } = parentEntity.data;
  if (Array.isArray(devices) && devices.length > 0) {
    devices.forEach(({
      Id, device, bidAdjustment, isBidAdjustmentNegative,
    }) => {
      deviceTargets.push(...getTargetCriterion({
        targets: [{ criterion: device, Id }],
        type: 'Device',
        propKey: 'DeviceName',
        campaignViewModel,
        adGroupViewModel,
        bidAdjustment: bidAdjustment * (isBidAdjustmentNegative ? -1 : 1),
      }));
    });
  }

  // age
  const ageTargets = parentEntity.data.ageRanges || [];
  const initialAgeTargets = parentEntity.data.initialAgeRanges || [];
  const addedAges = ageTargets.filter(target => initialAgeTargets.find(initialTarget => initialTarget.criterion === target) === undefined);
  const removedAges = initialAgeTargets.filter(initialTarget => ageTargets.find(target => initialTarget.criterion === target) === undefined).map(target => ({ ...target, status: 'Deleted' }));
  const addedAgeCriterion = getTargetCriterion({
    targets: addedAges.map(criterion => ({ criterion })), type: 'Age', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });
  const removedAgeCriterion = getTargetCriterion({
    targets: removedAges, type: 'Age', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  const negativeAgeRanges = parentEntity.data.negativeAgeRanges || [];
  const removedNegativeAges = negativeAgeRanges.filter(negativeAge => addedAges.find(addedTarget => addedTarget === negativeAge.criterion)).map(target => ({ ...target, status: 'Deleted' }));
  const removedNegativeAgeCriterion = getTargetCriterion({
    targets: removedNegativeAges, type: 'NegativeAge', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  // gender
  const genderTypes = parentEntity.data.genderTypes || [];
  const initialGenderTypes = parentEntity.data.initialGenderTypes || [];
  const addedGenders = genderTypes.filter(target => initialGenderTypes.find(initialTarget => initialTarget.criterion === target) === undefined);
  const removedGenders = initialGenderTypes.filter(initialTarget => genderTypes.find(target => initialTarget.criterion === target) === undefined).map(target => ({ ...target, status: 'Deleted' }));
  const addedGenderCriterion = getTargetCriterion({
    targets: addedGenders.map(criterion => ({ criterion })), type: 'Gender', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });
  const removedGenderCriterion = getTargetCriterion({
    targets: removedGenders, type: 'Gender', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  const negativeGenderTypes = parentEntity.data.negativeGenderTypes || [];
  const removedNegativeGenders = negativeGenderTypes.filter(negativeGender => addedGenders.find(addedTarget => addedTarget === negativeGender.criterion)).map(target => ({ ...target, status: 'Deleted' }));
  const removedNegativeGenderCriterion = getTargetCriterion({
    targets: removedNegativeGenders, type: 'NegativeGender', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  // industry
  let industryTargets = [];
  let negativeIndustryTargets = [];
  let initialIndustryTargets = [];
  let initialNegativeIndustryTargets = [];
  let addedIndustryTargets = [];
  let removedIndustryTargets = [];
  let addedIndustryCriterion = [];
  let removedIndustryCriterion = [];
  let negativeAddedIndustryTargets = [];
  let negativeRemovedIndustryTargets = [];
  let negativeAddedIndustryCriterion = [];
  let negativeRemovedIndustryCriterion = [];

  industryTargets = parentEntity.data.industry || [];
  initialIndustryTargets = parentEntity.data.initialIndustryTargets || [];

  negativeIndustryTargets = parentEntity.data.negativeIndustry || [];
  initialNegativeIndustryTargets = parentEntity.data.initialNegativeIndustryTargets || [];

  addedIndustryTargets = industryTargets.filter(target => initialIndustryTargets.find(initialTarget => initialTarget.criterion === target) === undefined);
  removedIndustryTargets = initialIndustryTargets.filter(initialTarget => industryTargets.find(target => initialTarget.criterion === target) === undefined).map(target => ({ ...target, status: 'Deleted' }));
  addedIndustryCriterion = getTargetCriterion({
    targets: addedIndustryTargets.map(criterion => ({ criterion })), type: 'Industry', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  removedIndustryCriterion = getTargetCriterion({
    targets: removedIndustryTargets, type: 'Industry', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  negativeAddedIndustryTargets = negativeIndustryTargets.filter(target => initialNegativeIndustryTargets.find(initialTarget => initialTarget.criterion === target) === undefined);
  negativeRemovedIndustryTargets = initialNegativeIndustryTargets.filter(initialTarget => negativeIndustryTargets.find(target => initialTarget.criterion === target) === undefined).map(target => ({ ...target, status: 'Deleted' }));
  negativeAddedIndustryCriterion = getTargetCriterion({
    targets: negativeAddedIndustryTargets.map(criterion => ({ criterion })), type: 'NegativeIndustry', propKey: 'Target', campaignViewModel, adGroupViewModel, overrideType: 'Industry',
  });

  negativeRemovedIndustryCriterion = getTargetCriterion({
    targets: negativeRemovedIndustryTargets, type: 'NegativeIndustry', propKey: 'Target', campaignViewModel, adGroupViewModel, overrideType: 'Industry',
  });

  // job target
  let jobTargets = [];
  let negativeJobTargets = [];
  let initialJobTargets = [];
  let initialNegativeJobTargets = [];
  let addedJobTargets = [];
  let removedJobTargets = [];
  let addedJobCriterion = [];
  let removedJobCriterion = [];
  let negativeAddedJobTargets = [];
  let negativeRemovedJobTargets = [];
  let negativeAddedJobCriterion = [];
  let negativeRemovedJobCriterion = [];

  jobTargets = parentEntity.data.jobTargets || [];
  initialJobTargets = parentEntity.data.initialJobTargets || [];

  negativeJobTargets = parentEntity.data.negativeJobTargets || [];
  initialNegativeJobTargets = parentEntity.data.initialNegativeJobTargets || [];

  addedJobTargets = jobTargets.filter(target => initialJobTargets.find(initialTarget => initialTarget.criterion === target) === undefined);
  removedJobTargets = initialJobTargets.filter(initialTarget => jobTargets.find(target => initialTarget.criterion === target) === undefined).map(target => ({ ...target, status: 'Deleted' }));
  addedJobCriterion = getTargetCriterion({
    targets: addedJobTargets.map(criterion => ({ criterion })), type: 'JobFunction', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  removedJobCriterion = getTargetCriterion({
    targets: removedJobTargets, type: 'JobFunction', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  negativeAddedJobTargets = negativeJobTargets.filter(target => initialNegativeJobTargets.find(initialTarget => initialTarget.criterion === target) === undefined);
  negativeRemovedJobTargets = initialNegativeJobTargets.filter(initialTarget => negativeJobTargets.find(target => initialTarget.criterion === target) === undefined).map(target => ({ ...target, status: 'Deleted' }));
  negativeAddedJobCriterion = getTargetCriterion({
    targets: negativeAddedJobTargets.map(criterion => ({ criterion })), type: 'NegativeJobFunction', propKey: 'Target', campaignViewModel, adGroupViewModel, overrideType: 'JobFunction',
  });

  negativeRemovedJobCriterion = getTargetCriterion({
    targets: negativeRemovedJobTargets, type: 'NegativeJobFunction', propKey: 'Target', campaignViewModel, adGroupViewModel, overrideType: 'JobFunction',
  });

  // companyName targets
  let companyNameTargets = [];
  let negativeCompanyNameTargets = [];
  let initialCompanyNameTargets = [];
  let initialNegativeCompanyNameTargets = [];
  let addedCompanyNameTargets = [];
  let removedCompanyNameTargets = [];
  let addedCompanyNameCriterion = [];
  let removedCompanyNameCriterion = [];
  let negativeAddedCompanyNameTargets = [];
  let negativeRemovedCompanyNameTargets = [];
  let negativeAddedCompanyNameCriterion = [];
  let negativeRemovedCompanyNameCriterion = [];

  companyNameTargets = parentEntity.data.companyNameTargets || [];
  initialCompanyNameTargets = parentEntity.data.initialCompanyNameTargets || [];


  negativeCompanyNameTargets = parentEntity.data.negativeCompanyNameTargets || [];
  initialNegativeCompanyNameTargets = parentEntity.data.initialNegativeCompanyNameTargets || [];

  addedCompanyNameTargets = companyNameTargets.filter(target => initialCompanyNameTargets.find(initialTarget => initialTarget.Target === target.Target) === undefined);
  removedCompanyNameTargets = initialCompanyNameTargets.filter(initialTarget => companyNameTargets.find(target => initialTarget.Target === target.Target) === undefined).map(target => ({ ...target, criterion: target.Target, status: 'Deleted' }));

  addedCompanyNameCriterion = getTargetCriterion({
    targets: addedCompanyNameTargets.map(criterion => ({ criterion })), type: 'CompanyName', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  removedCompanyNameCriterion = getTargetCriterion({
    targets: removedCompanyNameTargets, type: 'CompanyName', propKey: 'Target', campaignViewModel, adGroupViewModel,
  });

  negativeAddedCompanyNameTargets = negativeCompanyNameTargets.filter(target => initialNegativeCompanyNameTargets.find(initialTarget => initialTarget.Target === target.Target) === undefined);
  negativeRemovedCompanyNameTargets = initialNegativeCompanyNameTargets.filter(initialTarget => negativeCompanyNameTargets.find(target => initialTarget.Target === target.Target) === undefined).map(target => ({ ...target, criterion: target.Target, status: 'Deleted' }));

  negativeAddedCompanyNameCriterion = getTargetCriterion({
    targets: negativeAddedCompanyNameTargets.map(criterion => ({ criterion })), type: 'NegativeCompanyName', propKey: 'Target', campaignViewModel, adGroupViewModel, overrideType: 'CompanyName',
  });

  negativeRemovedCompanyNameCriterion = getTargetCriterion({
    targets: negativeRemovedCompanyNameTargets, type: 'NegativeCompanyName', propKey: 'Target', campaignViewModel, adGroupViewModel, overrideType: 'CompanyName',
  });


  return [
    ...deviceTargets,
    ...removedNegativeAgeCriterion,
    ...addedAgeCriterion,
    ...removedAgeCriterion,
    ...removedNegativeGenderCriterion,
    ...addedGenderCriterion,
    ...removedGenderCriterion,
    ...addedIndustryCriterion,
    ...removedIndustryCriterion,
    ...negativeAddedIndustryCriterion,
    ...negativeRemovedIndustryCriterion,
    ...addedJobCriterion,
    ...removedJobCriterion,
    ...negativeAddedJobCriterion,
    ...negativeRemovedJobCriterion,
    ...addedCompanyNameCriterion,
    ...removedCompanyNameCriterion,
    ...negativeAddedCompanyNameCriterion,
    ...negativeRemovedCompanyNameCriterion,
  ];
};

// Supports both campaign level and ad group level
// For campaign level, pass in campaignViewModel only
// Expects both wrapped in { data: ...}
export function getDeviceCriterionsFull(campaignViewModel, adGroupViewModel) {
  const parentEntity = adGroupViewModel || campaignViewModel;

  const deviceTargets = parentEntity.data.deviceTypes || [];
  const initialDeviceTargets = parentEntity.data.initialDeviceTypes || [];

  const addedBackDevices = initialDeviceTargets.filter(initialTarget => deviceTargets.find(target => initialTarget.criterion === target) && initialTarget.bidAdjustment === RemovedDeviceBidAdjustment)
    .map((device => ({ criterion: device.criterion, Id: device.Id })));
  const newlyAddedDevices = deviceTargets.filter(target => initialDeviceTargets.find(initialTarget => initialTarget.criterion === target) === undefined)
    .filter((device => addedBackDevices.find(addedBackDevice => addedBackDevice.criterion === device) === undefined));
  const removedDevices = initialDeviceTargets.filter(initialTarget => deviceTargets.find(target => initialTarget.criterion === target) === undefined);
  const addedDevices = [...addedBackDevices, ...newlyAddedDevices.map(criterion => ({ criterion }))];

  return { addedDevices, removedDevices };
}

const getTargetCriterionForCampaign = ({
  targets,
  type,
  propKey,
  campaignViewModel,
  bidAdjustment,
  overrideType = undefined,
}) => targets.map((target) => {
  const criterion = {
    Type: overrideType || type,
    BidAdjustment: bidAdjustment,
    [`${overrideType || type}Criterion`]: {
      [propKey]: typeof (target.criterion) === 'object' ? target.criterion.Target : target.criterion,
    },
  };
  if (campaignViewModel.data.Id) {
    return {
      Id: target.Id,
      Status: target.status ? target.status : 'Active',
      Criterion: criterion,
      CriterionType: type,
      Campaign: {
        Id: campaignViewModel.data.Id,
      },
    };
  }
  return {
    Criterion: criterion,
    CriterionType: type,
    CampaignName: campaignViewModel.data.Name,
    Campaign: {
      Id: PLACEHOLDER_ID.CampaignNegativeReferenceId,
    },
  };
});

export const viewModelToBulkModelForLocationTargets = ({ bundleLocationCriterions, campaignViewModel }) => {
  if (!campaignViewModel.data.locationTargets || campaignViewModel.data.locationRestricted) {
    return [];
  }

  const bulkUpsertModel = convertLocationStateToLocationSchemaCampaign(
    campaignViewModel.data.locationTargets,
    bundleLocationCriterions,
    {
      bidStrategy: { option: 'placeholder' },
      ...campaignViewModel.data,
    }
  );

  return bulkUpsertModel;
};

export const modelToViewModelForTargetCriterions = ({ model }) => {
  const viewModel = modelToViewModelForTargetCriterionsBase({ model, level: CRITERION_LEVEL.CAMPAIGN });

  const deviceTypesOverride = viewModel.initialDeviceTypes && viewModel.initialDeviceTypes.map(target => ({
    Id: target.Id,
    device: target.criterion,
    isBidAdjustmentNegative: target.bidAdjustment < 0,
    bidAdjustment: Math.abs(target.bidAdjustment),
  }));

  return {
    ...omit(viewModel, 'initialDeviceTypes', 'deviceTypes'),
    devices: deviceTypesOverride,
  };
};
